import { getFirstDef } from '../objtools'

export function stateGetLangCode(state) {
  return getFirstDef(state.lang, 'lang_code', 'en')
}
